import { createPhoneInputValidator } from '@applyboard/crystal-ui';

export function phoneInputValidatorBuilder(optional: boolean = false) {
  return (value: string | undefined) => {
    if (optional && (!value || value.length < 5)) {
      // since the max country code with + digit is 4.
      return true;
    }
    return createPhoneInputValidator()(value); // sigh... geniuses for not exposing the actual useful `validatePhoneNumber` functionality.
  };
}
